import Icon from "../selfcare/Icon.tsx";
import {OpeningHours, PhoneNumbers} from "../../util/contact.ts";
import {shouldShowWinterHolidayWarning} from "../../util/helpers.ts";
import ContactDecemberClosedDays from "./ContactDecemberClosedDays.tsx";
import ContactFormComponent from "./ContactFormComponent.tsx";
import {useState} from "react";
import PhoneNumberSpanComponent from "../callMe/PhoneNumberSpanComponent.tsx";
import {uid} from "../raffle/uid.ts";
import IconPhone from "../icons/IconPhone.tsx";
import IconChat from "../icons/IconChat.tsx";
import IconDocument from "../icons/IconDocument.tsx";

export default function ContactDetailsComponent(props: { hide?: boolean, phone?: boolean, chat?: boolean, form?: boolean }) {
    const [showFormFields, setShowFormFields] = useState<boolean>(false);

    const [raffleHidden, setRaffleHidden] = useState<boolean>(false);

    const timeSlots = [
        {
            time: 'kl. 09-10',
            className: 'most-busy'
        },
        {
            time: 'kl. 10-11',
            className: 'busy'
        },
        {
            time: 'kl. 11-12',
            className: 'busy'
        },
        {
            time: 'kl. 12-13',
            className: 'least-busy'
        },
        {
            time: 'kl. 13-14',
            className: 'least-busy'
        },
        {
            time: 'kl. 14-15',
            className: 'busy'
        },
    ];

    return (
        <>
            <section className={`contact-options ${props.hide === true ? '' : 'visible'}`}>
                <div className="grid grid--contact">
                    {props.phone === true && (
                        <a href={`tel:+45${PhoneNumbers.Default}`} className="grid-item grid-item--phone">
                            <Icon component={IconPhone}/>
                            <div className="text">
                                <p className="phone-number">
                                    <PhoneNumberSpanComponent phoneNo={PhoneNumbers.Default} />
                                </p>
                                <p>
                                    <strong>Man-Fre:</strong> {OpeningHours.Phone}
                                </p>
                            </div>
                        </a>
                    )}
                    {props.chat === true && (
                        <button
                            className="grid-item grid-item--chat" onClick={() => {
                            setRaffleHidden((v) => !v)
                            if (raffleHidden) {
                                window.raffleApi.show(uid.chat)
                                window.zE.hide()
                            } else {
                                window.raffleApi.hide(uid.chat)
                                window.zE.activate()
                            }
                        }}
                        >
                            <Icon component={IconChat}/>
                            <div className="text">
                                <p>Chat med os</p>
                                <p>
                                    <strong>Man-Fre:</strong> {OpeningHours.Chat.MonFri}<br/>
                                    <strong>Weekend:</strong> {OpeningHours.Chat.SunSat}
                                </p>
                            </div>
                        </button>
                    )}
                    {props.form === true && (
                        <button className="grid-item grid-item--form" onClick={() => setShowFormFields((v) => !v)}>
                            <Icon component={IconDocument}/>
                            <div className="text">
                                <p>Kontaktformular</p>
                                <p>Besvares løbende</p>
                            </div>
                        </button>
                    )}
                </div>
                {showFormFields && (
                    <ContactFormComponent/>
                )}

                {shouldShowWinterHolidayWarning() && (
                    <ContactDecemberClosedDays/>
                )}

                {props.phone === true && (
                    <div className={'content'}>
                        <h3 className={'heading heading--montserrat heading--small'}>Se hvornår vi har mest travlt på telefonerne:</h3>
                        <div className={'contact-phone-graph'}>
                            {timeSlots.map((slot, index) => (
                                <div key={index} className={`contact-phone-graph-item ${slot.className}`}>
                                    <p>{slot.time}</p>
                                    <span/>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </section>
        </>
    )
}
